export enum DataSourceStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  PARTIALLY_ACTIVE = 'PARTIAL',
}